import { FilterTranslationMap } from '../model';

type FilterDialogHiddenA11yProps = {
	numberOfResults: number | undefined;
	translationMap: FilterTranslationMap;
};

const FilterDialogHiddenA11y: React.FC<FilterDialogHiddenA11yProps> = ({
	numberOfResults,
	translationMap,
}) => {
	const getAriaStatusText = () => {
		if (numberOfResults === 1) {
			return translationMap.ariaStatusSingle;
		} else {
			return translationMap.ariaStatusPlural.replace(
				'{0}',
				`${numberOfResults}`
			);
		}
	};

	return (
		<div
			role="status"
			aria-live="polite"
			aria-relevant="additions"
			className="ui-helper-hidden-accessible"
		>
			<div key={numberOfResults}>{numberOfResults && getAriaStatusText()}</div>
		</div>
	);
};

export default FilterDialogHiddenA11y;
